export function connectGitHub(): Promise<void> {
  const clientId = process.env.REACT_APP_GITHUB_CLIENT_ID;
  if (!clientId) {
    return Promise.reject(new Error('REACT_APP_GITHUB_CLIENT_ID not configured'));
  }
  const redirectUri = `${window.location.origin}/github/callback`;
  const url = `https://github.com/login/oauth/authorize?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=repo`;
  const popup = window.open(url, 'github-oauth', 'width=600,height=700');
  return new Promise((resolve) => {
    const timer = setInterval(() => {
      if (popup?.closed) {
        clearInterval(timer);
        resolve();
      }
    }, 500);
  });
}
